import { jwtDecode as jwt_decode } from 'jwt-decode';
import React, { createContext, useContext, useEffect, useState } from 'react';
import Auth, { ACCESS_TOKEN_KEY } from '../utils/auth';

const UserContext = createContext();
const UserProvider = ({ children }) => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [user, setUser] = useState({});
	// const navigate = useNavigate();
	const [loginPending, setLoginPending] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	// handles auto login if token is present
	const fetchUser = async () => {
		// check for token
		console.log('inside fetch user');
		if (Auth.getToken()) {
			setLoginPending(true);
			try {
				console.log('token found');
				const token = Auth.getToken();
				console.log({ token });

				if (token !== null) {
					// send to backend to validate
					const res = await Auth.getUser(token);
					if (res.success) {
						setIsLoggedIn(true);
						setUser(res.user);
					} else {
						setUser({});
						setIsLoggedIn(false);
					}
				} else {
					setUser({});
					setIsLoggedIn(false);
				}
				setLoginPending(false);
			} catch (error) {
				setIsLoggedIn(false);
				return console.error('Error: ' + error.message);
			}
		} else {
			console.log(Auth.getToken());
			return console.log('no token');
		}
	};

	// TODO: Test this
	// function checkAndClearJWT() {
	// 	const jwt = sessionStorage.getItem(ACCESS_TOKEN_KEY);
	// 	if (jwt) {
	// 		try {
	// 			const decoded = jwt_decode(jwt);
	// 			const now = Date.now() / 1000;
	// 			if (decoded.exp && now > decoded.exp) {
	// 				sessionStorage.removeItem(ACCESS_TOKEN_KEY);
	// 			}
	// 		} catch (error) {
	// 			console.error('Error decoding JWT:', error);
	// 		}
	// 	}
	// }
	useEffect(() => {
		fetchUser();
	}, []);
	useEffect(() => {
		console.log({ user });
	}, [user]);

	// useEffect(() => {
	// 	if (user && !user.isVerified) {
	// 		navigate('/verify', { replace: true });
	// 	}
	// }, [user]);
	return (
		<UserContext.Provider
			value={{
				isLoggedIn,
				setIsLoggedIn,
				user,
				setUser,
				loginPending,
				setLoginPending,
				isAdmin,
				setIsAdmin,
			}}
		>
			{children}
		</UserContext.Provider>
	);
};

export const useUser = () => useContext(UserContext);

export default UserProvider;
